import HeadsetInterface from 'resources/headsets/headset-interface';

export default class EposHeadset extends HeadsetInterface {
    constructor(deviceInfo) {
        super(deviceInfo);
        this.sdk = deviceInfo.sdk;
    }

    attachCallbacks = (callbacks) => {
        this.callbacks = callbacks(this.id);

        this.sdk.on('EndCall', this.callbacks.onHangup);
        this.sdk.on('RejectCall', this.callbacks.onHangup);
        this.sdk.on('AcceptCall', this.callbacks.onAcceptCall);
        this.sdk.on('MuteMicrophone', (mute) => {
            if (mute) {
                this.callbacks.onMuteEvent();
            } else {
                this.callbacks.onUnmuteEvent();
            }
        });
        this.sdk.on('HoldCall', this.callbacks.onHoldCall);
        this.sdk.on('ResumeCall', this.callbacks.onUnholdCall);
        // Redial and Offhook not implemented at the moment
        // Redial would redial the last called number
        // Offhook would prepare the user for making an outgoing call, in traditional phones by playing
        // a dial tone. In our case, maybe open the dialpad or something.
        //this.sdk.on('Redial', );
        //this.sdk.on('Offhook', );

        return this;
    };

    incomingCallImpl(callId) {
        this.sdk.SendIncomingCallEvent(callId);
    }
    outgoingCallImpl(callId) {
        this.sdk.SendOutgoingCallEvent(callId);
    }
    confirmCallImpl(callId) {
        this.sdk.SendActiveCallEvent(callId);
    }
    endCallImpl(callId) {
        this.sdk.SendEndCallEvent(callId);
    }
    holdCallImpl(callId) {
        this.sdk.SendHoldCallEvent(callId);
    }
    resumeCallImpl(callId) {
        this.sdk.SendUnholdCallEvent(callId);
    }
    muteCallImpl() {
        this.sdk.SendMuteStatus(true);
    }
    unmuteCallImpl() {
        this.sdk.SendMuteStatus(false);
    }
    onDisconnectImpl() {
        this.sdk.SendTerminateEvent();
    }
    userUnavailable() {
        this.sdk.SendPresenceEvent('Away');
    }
    userAvailable() {
        this.sdk.SendPresenceEvent('Available');
    }
}
